export default {
      id: "tj-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#tj",
      toString: function () {
        return this.url;
      }
    }